import React from 'react';
import { useNavigate } from 'react-router-dom';
import { QuizConfig } from '../types/quiz';
import { hasCompletedQuiz } from '../utils/resultHistory';

interface QuizCardProps {
  quiz: QuizConfig;
}

const QuizCard: React.FC<QuizCardProps> = ({ quiz }) => {
  const navigate = useNavigate();
  const completed = hasCompletedQuiz(quiz.id);

  return (
    <div
      className="quiz-card"
      onClick={() => navigate(`/quiz/${quiz.id}`)}
      style={{
        background: `linear-gradient(135deg, ${quiz.gradient[0]}, ${quiz.gradient[1]})`,
      }}
    >
      {completed && <div className="quiz-card-badge">✅</div>}
      <div className="quiz-card-icon">{quiz.icon}</div>
      <div className="quiz-card-title">{quiz.title}</div>
      <div className="quiz-card-description">{quiz.description}</div>
      <button className="quiz-card-button" onClick={(e) => { e.stopPropagation(); navigate(`/quiz/${quiz.id}`); }}>
        {completed ? '다시 테스트하기' : '시작하기'}
      </button>
    </div>
  );
};

export default QuizCard;
